
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Page, Content } from '@drawbotics/react-drylus';
import Playground, { PropsTable } from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Page and Content`}</h1>
<p>{`These are the basic building blocks for any UI using the design system. You should always import them and use them at the root of the project (the same place where you'd be using the `}<a parentName="p" {...{
        "href": "/base/providers"
      }}>{`providers`}</a>{`).`}</p>
<p>{`Use the import like so`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Page, Content } from '@drawbotics/react-drylus';
`}</code></pre>
<p>{`Each component takes the following props:`}</p>
<p><strong parentName="p">{`Page`}</strong></p>
<PropsTable component={Page} mdxType="PropsTable" />
<p><inlineCode parentName="p">{`Page`}</inlineCode>{` essentially defines the available space on the UI where your app will live, pretty much setting the height and width as a container.`}</p>
<p><strong parentName="p">{`Content`}</strong></p>
<PropsTable component={Content} mdxType="PropsTable" />
<p><inlineCode parentName="p">{`Content`}</inlineCode>{` takes care of properly setting the space taken by the content, and adds the background color which is normally used to define where the "main" content of the page lives.`}</p>
<p>{`And to construct a simple page you would do the following:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const App = () => {
  return (
    <YourRouter>
      <DrylusProvider>
        <Page>
          <Content fullHeight fullWidth>
            // the rest of the app goes here
          </Content>
        </Page>
      </DrylusProvider>
    </YourRouter>
  );
};
`}</code></pre>
<p>{`Or if you require a more complex root layout (see `}<a parentName="p" {...{
        "href": "/layout/layout"
      }}><inlineCode parentName="a">{`Layout`}</inlineCode></a>{`) for more examples.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const App = () => {
  return (
    <YourRouter>
      <DrylusProvider>
        <Page>
          <Layout bar={<YourBarComponent />} position={Position.LEFT}>
            <Content fullHeight>
              // the rest of the app goes here
            </Content>
          </Layout>
        </Page>
      </DrylusProvider>
    </YourRouter>
  );
};
`}</code></pre>
<h3>{`Example`}</h3>
<Playground __position={2} __code={`<Page style={{ display: 'flex' }}>
  <Content fullHeight fullWidth>
    I am some content
  </Content>
</Page>`} mdxType="Playground">
  <Page style={{
        display: 'flex'
      }} mdxType="Page">
    <Content fullHeight fullWidth mdxType="Content">
      I am some content
    </Content>
  </Page>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;